import React, { useState } from "react";
import SubSearch from "./components/SubSearch";
import SubFilter from "./components/SubFilter";

export default function SubFilterSearch({
  setvCursoFiltro = () => {},
  setLastSearchText = () => {},
  setHasSearched = () => {},
}) {
  const [vCategoriesSelected, setVCategoriesSelected] = useState([]);

  return (
    <div className="filtros-barra-busqueda" data-figma-id="810:15714">
      <SubFilter
        vCategoriesSelected={vCategoriesSelected}
        setVCategoriesSelected={setVCategoriesSelected}
      />
      <SubSearch
        vCategoriesSelected={vCategoriesSelected}
        setvCursoFiltro={setvCursoFiltro}
        setLastSearchText={setLastSearchText}
        setHasSearched={setHasSearched}
      />
    </div>
  );
}
